import { Row, Col } from 'antd'
import ViewContainer from './container'
import {
  StyledSuggestedProductsWrapper,
  StyledMobileSuggestedCarousel
} from '../styles'
import ProductBox from 'components/ProductBox'
import ProductsLoader from 'components/ProductsLoader'
import MediumContainer from 'components/MediumContainer'

const carouselSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
}

export default function Index ({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({ state, suggestedProducts }) => (
        <MediumContainer>
          <Row justify='center' style={{ marginTop: 30 }}>
            <Col xs={{ span: 0 }} md={{ span: 24 }}>
              <StyledSuggestedProductsWrapper gutter={[0, 42]}>
                {state.featuredProducts.status === 1 && (<ProductsLoader count={3} />)}
                {state.featuredProducts.status === 2 && suggestedProducts.length > 0 && (
                  <Col span={24}>
                    <h2>Recommended for you</h2>
                  </Col>
                )}
              </StyledSuggestedProductsWrapper>
            </Col>
            <Col xs={{ span: 24 }} md={{ span: 0 }}>
              {state.featuredProducts.status === 1 && (<ProductsLoader count={1} />)}
              {state.featuredProducts.status === 2 && suggestedProducts.length > 0 && (
              <>
                <h2 style={{ color: 'var(--cognac)' }}>Recommended for you</h2>
                <StyledMobileSuggestedCarousel {...carouselSettings}>
                  {suggestedProducts.map((product, index) => (
                    <ProductBox key={index} product={product.product_data} mode='small' />
                  ))}
                </StyledMobileSuggestedCarousel>
              </>
              )}
            </Col>
          </Row>
          <Row>
            {suggestedProducts.map((product) => (
              <ProductBox key={product.id} product={product.product_data} mode='small' />
            ))}
          </Row>
        </MediumContainer>
      )}
    </ViewContainer>
  )
}
